import { render, staticRenderFns } from "./create-variant.vue?vue&type=template&id=e288ba80&"
import script from "./create-variant.vue?vue&type=script&lang=js&"
export * from "./create-variant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports